import React from "react";
import Label from "components/lib/Shared/Label";
import { EMPLOYEE, CHANGE_TYPES } from "components/Employee/config/options";

const SelectChangeForm = ({
    setFieldValue,
    formStepErrors,
    values,
}) => {
    const handleDesignationChange = (event) => {
        setFieldValue("designation", event.target.value);
    };

    const handleIdTypeChange = (event) => {
        setFieldValue("idType", event.target.value);
    };

    return (
        <div className="mt-4">
            <div className="px-4 py-6 mt-2 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
                <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                        <Label htmlFor="designation">Designation</Label>
                        <select
                            name="designation"
                            className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            id="designation"
                            onChange={handleDesignationChange}
                            value={values.designation}
                        >
                            <option value="">Select designation</option>
                            {EMPLOYEE.map((official) => (
                                <option key={official.id} value={official.title}>
                                    {official.title}
                                </option>
                            ))}
                        </select>
                        {formStepErrors.designation && (
                            <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
                                {formStepErrors.designation}
                            </small>
                        )}
                    </div>
                    <div className="col-span-6 sm:col-span-3">
                        <Label htmlFor="idType">ID Types</Label>
                        <select
                            name="idType"
                            className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            id="idType"
                            onChange={handleIdTypeChange}
                            value={values.idType}
                        >
                            <option value="">Select ID Types</option>
                            {CHANGE_TYPES.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                        {formStepErrors.idType && (
                            <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
                                {formStepErrors.idType}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectChangeForm;
